import { memo } from "react"
import { mdlRssFeedData } from "../../models/domain/RssFeedData"
import { Button, Table, TableProps } from "antd"
import { t } from "i18next"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExternalLink } from "@fortawesome/free-solid-svg-icons"
import dayjs from "dayjs"

export type TourismNewsTableProps = {
    dataSource?: mdlRssFeedData[],
    onReadMore?: Function
}

export const TourismNewsTable = memo(function TourismNewsTable(props: TourismNewsTableProps) {
    const cleanHtmlEntities = (newsDescription: string) => newsDescription && newsDescription.replaceAll(/&#\d+;/g, '').replaceAll(/\[\]/g, '').replaceAll(/<[^>]*>?/gm, '');

    const columns: TableProps<mdlRssFeedData>["columns"] = [
        {
            title: t("tourismNews.date"),
            dataIndex: "pubDate",
            key: "pubDate",
            className: "table-item-no-wrap",
            render: (pubDate: string) => {
                const publishDatTime = dayjs(pubDate);
                return publishDatTime.isValid() ? publishDatTime.format("DD-MM-YYYY") : "-"
            }
        },
        {
            title: t("tourismNews.newsTitle"),
            dataIndex: "title",
            key: "title"
        },
        {
            title: t("tourismNews.description"),
            dataIndex: "description",
            key: "description",
            render: (e: mdlRssFeedData, record) => (
                <p>{cleanHtmlEntities(record.description)}...</p>
            )
        },
        {
            title: t("common.actions"),
            key: "open",
            render: (e: mdlRssFeedData, record) => (
                <Button type="primary" className="btn-second" onClick={() => props.onReadMore ? props.onReadMore(record.link) : undefined}>
                    <FontAwesomeIcon icon={faExternalLink} />{t("tourismNews.readMore")}
                </Button>
            )
        }
    ]

    return (
        <>
            {
                props.dataSource
                &&
                <Table<mdlRssFeedData>
                    className="mt-2"
                    size="middle"
                    columns={columns}
                    dataSource={props.dataSource.map((rssFeedData: mdlRssFeedData, index: number) => ({ ...rssFeedData, key: index }))}
                />
            }
        </>
    )
})